import AlphaBisabolol from 'assets/terpenes/alpha-bisabolol';
import AlphaPinene from 'assets/terpenes/alpha-pinene';
import BetaCaryophyllene from 'assets/terpenes/beta-caryophyllene';
import BetaCaryophylleneOxide from 'assets/terpenes/beta-caryophyllene-oxide';
import BetaEudesmol from 'assets/terpenes/beta-eudesmol';
import BetaMyrcene from 'assets/terpenes/beta-myrcene';
import BetaPinene from 'assets/terpenes/beta-pinene';
import Bisabolol from 'assets/terpenes/bisabolol';
import Camphene from 'assets/terpenes/camphene';
import Camphor from 'assets/terpenes/camphor';
import Caryophyllene from 'assets/terpenes/caryophyllene';
import CaryophylleneOxide from 'assets/terpenes/caryophyllene-oxide';
import Cedrene from 'assets/terpenes/cedrene';
import Citral from 'assets/terpenes/citral';
import Citronellol from 'assets/terpenes/citronellol';
import Cymene from 'assets/terpenes/cymene';
import Eucalyptol from 'assets/terpenes/eucalyptol';
import Fenchol from 'assets/terpenes/fenchol';
import Geraniol from 'assets/terpenes/geraniol';
import Guaiol from 'assets/terpenes/guaiol';
import GeranylAcetate from 'assets/terpenes/geranyl-acetate';
import Humulene from 'assets/terpenes/humulene';
import Isoborneol from 'assets/terpenes/isoborneol';
import Isopulegol from 'assets/terpenes/isopulegol';
import Limonene from 'assets/terpenes/limonene';
import Linalool from 'assets/terpenes/linalool';
import Myrcene from 'assets/terpenes/myrcene';
import Ocimene from 'assets/terpenes/ocimene';
import Ocimene1 from 'assets/terpenes/ocimene1';
import Ocimene2 from 'assets/terpenes/ocimene2';
import ParaCymene from 'assets/terpenes/para-cymene';
import ParaIsopropyltouluene from 'assets/terpenes/para-isopropyltouluene';
import Pinene from 'assets/terpenes/pinene';
import Sabinene from 'assets/terpenes/sabinene';
import Terpinene from 'assets/terpenes/terpinene';
import Terpineol from 'assets/terpenes/terpineol';
import Terpinolene from 'assets/terpenes/terpinolene';
import Nerolidol from 'assets/terpenes/nerolidol';
import Nerolidol2 from 'assets/terpenes/nerolidol2';
import TransNerolidol from 'assets/terpenes/trans-nerolidol';
import Valencene from 'assets/terpenes/valencene';

const terpeneIcons = {
  'alpha-bisabolol': {
    icon: AlphaBisabolol,
    width: '37px',
  },
  'alpha-pinene': {
    icon: AlphaPinene,
    width: '30px',
  },
  'alpha-terpinene': {
    icon: Terpinene,
    width: '30px',
  },
  'beta-caryophyllene': {
    icon: BetaCaryophyllene,
    width: '28px',
  },
  'beta-caryophyllene-oxide': {
    icon: BetaCaryophylleneOxide,
    width: '29px',
  },
  'beta-eudesmol': {
    icon: BetaEudesmol,
    width: '30px',
  },
  'beta-myrcene': {
    icon: BetaMyrcene,
    width: '30px',
  },
  'beta-pinene': {
    icon: BetaPinene,
    width: '30px',
  },
  bisabolol: {
    icon: Bisabolol,
    width: '30px',
  },
  camphene: {
    icon: Camphene,
    width: '29px',
  },
  camphor: {
    icon: Camphor,
    width: '29px',
  },
  caryophyllene: {
    icon: Caryophyllene,
    width: '29px',
  },
  'caryophyllene-oxide': {
    icon: CaryophylleneOxide,
    width: '26px',
  },
  cedrene: {
    icon: Cedrene,
    width: '26px',
  },
  citral: {
    icon: Citral,
    width: '26px',
  },
  citronellol: {
    icon: Citronellol,
    width: '29px',
  },
  cymene: {
    icon: Cymene,
    width: '27px',
  },
  eucalyptol: {
    icon: Eucalyptol,
    width: '27px',
  },
  fenchol: {
    icon: Fenchol,
    width: '30px',
  },
  geraniol: {
    icon: Geraniol,
    width: '30px',
  },
  'geranyl-acetate': {
    icon: GeranylAcetate,
    width: '25px',
  },
  guaiol: {
    icon: Guaiol,
    width: '28px',
  },
  humulene: {
    icon: Humulene,
    width: '26px',
  },
  isoborneol: {
    icon: Isoborneol,
    width: '28px',
  },
  isopulegol: {
    icon: Isopulegol,
    width: '28px',
  },
  limonene: {
    icon: Limonene,
    width: '30px',
  },
  linalool: {
    icon: Linalool,
    width: '27px',
  },
  myrcene: {
    icon: Myrcene,
    width: '25px',
  },
  nerolidol: {
    icon: Nerolidol,
    width: '28px',
  },
  'nerolidol-2': {
    icon: Nerolidol2,
    width: '30px',
  },
  ocimene: {
    icon: Ocimene,
    width: '27px',
  },
  'ocimene-1': {
    icon: Ocimene1,
    width: '30px',
  },
  'ocimene-2': {
    icon: Ocimene2,
    width: '30px',
  },
  'p-cymene': {
    icon: ParaCymene,
    width: '30px',
  },
  'p-isopropyltouluene': {
    icon: ParaIsopropyltouluene,
    width: '28px',
  },
  'para-cymene': {
    icon: ParaCymene,
    width: '30px',
  },
  'para-isopropyltouluene': {
    icon: ParaIsopropyltouluene,
    width: '28px',
  },
  pinene: {
    icon: Pinene,
    width: '28px',
  },
  sabinene: {
    icon: Sabinene,
    width: '25px',
  },
  terpinene: {
    icon: Terpinene,
    width: '30px',
  },
  terpineol: {
    icon: Terpineol,
    width: '23px',
  },
  terpinolene: {
    icon: Terpinolene,
    width: '25px',
  },
  'trans-nerolidol': {
    icon: TransNerolidol,
    width: '28px',
  },
  valencene: {
    icon: Valencene,
    width: '29px',
  },
};

export default terpeneIcons;
